import React, { ReactNode, ReactNodeArray, CSSProperties } from 'react'
import EpiComponent from '@episerver/spa-core/EpiComponent'
import LawClassActionBlockData from '../../../Models/Content/LawClassActionBlockData';
import LawClassActionSearchComponent from './LawClassActionSearchComponent';

export default class LawClassActionBlock extends EpiComponent<LawClassActionBlockData> {
   
    public render(): null | ReactNode | ReactNodeArray {


        return (
            <LawClassActionSearchComponent context={this.getContext()} contentData={this.props.data}/>
        )
    }
}